import { Button } from "components/UI/Buttons/Button";
import Link from "next/link";
import s from "./BlogTopWriters.module.scss";
import cs from "@/styles/modules/card.module.scss";
import { useBlogPageContext } from "@/helpers/contexts/BlogPageContext";
import cn from "classnames";
import Image from "next/image";

export const BlogTopWriters = () => {
  const data = useBlogPageContext();
  if (!data) return null;
  const { authors } = data;

  return (
    <div className={cn(cs.cardGlassHover, s.wrapper)}>
      <div className={s.text}>Check out our top writers:</div>
      <div className={s.authors}>
        {authors.map(({ url, name, avatar }) => (
          <Link href={url} key={url} className={s.authorWrapper} prefetch={false}>
            <Image src={avatar.url} alt={avatar.alt} width={54} height={54} className={s.authorPhoto} />
            <div className={s.authorName}>
              <div className={s.authorFirstName}>{name.split(" ")[0]}</div>
              <div className={s.authorSecondName}>{name.split(" ").pop()}</div>
            </div>
          </Link>
        ))}
      </div>
      <Button type="white" iconPosition="suffix" outline className={s.button} href="/authors">
        Show All
      </Button>
    </div>
  );
};
